<template>
  <div class="relative mr-4">
    <input
      v-model="keyword"
      type="text"
      placeholder="Search instance here ..."
      @focus="handleShowList"
      @blur="handleHideList"
      class="block w-[500px] py-2 px-3 bg-white text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
    />

    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
      mode="out-in"
    >
      <div
        v-if="getGlobalInstanceLoading"
        class="absolute top-0 right-0 w-[38px] h-[38px] p-2 flex items-center justify-center"
      >
        <div
          style="border-top-color: transparent"
          class="w-4 h-4 border-4 border-gray-500 border-solid rounded-full animate-spin"
        ></div>
      </div>
    </transition>
    <div
      v-if="showList"
      class="bg-white mt-2 p-2 rounded absolute z-10 shadow right-0 min-w-[500px] max-h-[400px] overflow-auto"
    >
      <ul>
        <li
          @mousedown="handleRedirect(result)"
          class="hover:bg-gray-100 p-4 rounded cursor-pointer"
          v-for="(result, index) in getGlobalInstanceSearch"
          :key="index"
        >
          <p
            v-html="highLight(result.instance_name.split('|')[1], keyword)"
            class="font-bold text-gray-500 mb-2"
          ></p>
          <p class="text-sm">
            {{
              getComponentName(result.instance_name.split("|")[0])
                .replaceAll("_", " ")
                .toUpperCase()
            }}
          </p>
        </li>
      </ul>
    </div>
    <div
      v-if="keyword && !getGlobalInstanceSearch.length"
      class="bg-white mt-2 p-2 rounded absolute z-10 shadow right-0 min-w-[500px] max-h-[400px] overflow-auto"
    >
      <div class="my-[20px] text-sm flex items-center justify-center">
        <p>No Results</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "underscore";
import * as Actions from "@/store/actions.type";

export default {
  name: "GlobalSearchBar",
  data() {
    return {
      keyword: "",
      showList: false
    };
  },
  created() {
    this.debounceFn = _.debounce(() => {
      this.$store.dispatch(Actions.GLOBAL_SEARCH_INSTANCE, {
        region: this.getRegion,
        keyword:
          this.keyword === "_" || this.keyword === "%"
            ? "\\" + this.keyword
            : this.keyword
      });
    }, 500);
  },
  watch: {
    getGlobalInstanceSearch() {
      if (this.getGlobalInstanceSearch.length) {
        this.showList = true;
      }
    },
    keyword() {
      if (this.keyword) {
        this.$store.dispatch(Actions.CLEAR_GLOBAL_SEARCH_RESULT);
        this.debounceFn();
      } else {
        this.showList = false;
        this.$store.dispatch(Actions.CLEAR_GLOBAL_SEARCH_RESULT);
      }
    }
  },
  computed: {
    ...mapGetters([
      "getGlobalInstanceSearch",
      "getGlobalInstanceLoading",
      "getRegion"
    ])
  },
  methods: {
    getComponentName(id) {
      const components = JSON.parse(
        localStorage.getItem(`abi_${this.getRegion}_components`)
      ).data;
      const component_name = components.find((item) => {
        return item.id === id;
      }).name;
      return component_name;
    },
    highLight(text, keyword) {
      let index = text.toLowerCase().indexOf(keyword.toLowerCase());
      if (index >= 0) {
        return (
          text.substring(0, index) +
          "<span class='text-blue-500'>" +
          text.substring(index, index + keyword.length) +
          "</span>" +
          text.substring(index + keyword.length)
        );
      }
    },
    handleRedirect(item) {
      this.$router.push(`/component/edit/${item.comp_id}/${item.id}`);
    },
    handleShowList() {
      if (
        this.getGlobalInstanceSearch.length &&
        this.keyword &&
        !this.getGlobalInstanceLoading
      ) {
        this.showList = true;
      }
    },
    handleHideList() {
      this.showList = false;
    }
  }
};
</script>
